<template>
  <div v-if="fellingDescriptions.length">
    <div class="title">
      <!-- Причины назначения в рубку деревьев категорий состояния 2-4 -->
      Запретить в рубку деревья категорий состояния
    </div>
    <div>
      <div v-for="stateCat in stateCats" :key="stateCat.id">
        <div class="subtitle">
          Категория {{ stateCat.id }}: {{ stateCat.name }}
        </div>
        <template v-for="description in fellingDescriptions">
          <div
            v-if="stateCat.id === description.state_cat_id"
            :key="`${description.state_cat_id}-${description.description_id}`"
            class="checkbox-container"
          >
            <p-checkbox
              :binary="true"
              :modelValue="!!description.id"
              :id="`${description.state_cat_id}-${description.description_id}`"
              :disabled="loading || !$store.getters['lpoData/actLpoIsDraft'] || isOnlyDeadFelling"
              @change="
                (event) => handleChange(description, event.target.checked)
              "
            />
            <label
              :for="`${description.state_cat_id}-${description.description_id}`"
              >{{ description.description }}</label
            >
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchFellingDescriptions,
  addFellingDescription,
  removeFellingDescription,
  removeFellingDescriptions,
} from "./fellingDescriptions.api";

export default {
  props: {
    isOnlyDeadFelling: {
				type: Boolean,
				default: null
			}
  },
  data: () => ({
    fellingDescriptions: [],
    loading: false,
  }),
  watch: {
			'isOnlyDeadFelling': async function(value) {
        if(value) {
          if(this.fellingDescriptions.filter((element) => { return element.id !== null }).length > 0) {
            await removeFellingDescriptions(this.fellingDescriptions);
            //const lpo_id = this.$store.state.selectedLpo.lpo?.lpo_id;
            //this.fellingDescriptions = (await fetchFellingDescriptions(lpo_id)) || [];
            //const aaa = this.fellingDescriptions.map((element) => { return element })
            this.fellingDescriptions.map((element) => {
              element.id = null
              return element})
          }
        }
      }
		},
  computed: {
    stateCats() {
      const allStateCats = this.fellingDescriptions.map((desc) => ({
        id: desc.state_cat_id,
        name: desc.state_cat,
      }));

      const result = [];

      for (const stateCat of allStateCats) {
        if (!result.find((cat) => cat.id === stateCat.id)) {
          result.push(stateCat);
        }
      }

      return result;
    },
  },

  methods: {
    async handleChange(description, checked) {
      const lpo_id = this.$store.state.selectedLpo.lpo?.lpo_id;
      this.loading = true;

      if (!description.id) {
        await addFellingDescription(lpo_id, description);
      }

      if (!checked && description.id) {
        await removeFellingDescription(description.id);
      }
      this.fellingDescriptions = (await fetchFellingDescriptions(lpo_id)) || [];
      this.loading = false;
    }
  },

  async created() {
    const lpo_id = this.$store.state.selectedLpo.lpo?.lpo_id;
    this.fellingDescriptions = (await fetchFellingDescriptions(lpo_id)) || [];
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-style: italic;
  margin: 0.5rem 0;
}

.checkbox-container {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.2rem;
}
.checkbox-container > label {
  cursor: pointer;
}
</style>
